import { createRef } from "react"

import Link from "~/components/atoms/Link"
import Pc from "~/components/atoms/Pc"
import Sp from "~/components/atoms/Sp"
import Typography from "~/components/atoms/Typography"
import { Color } from "~/consts/style-mixins"
import { Heading } from "~/pages/next/new-grad-jobs/consultation"
import { internalLink, staticPath } from "~/services/helper"

import * as styled from "./styled"

export const InfraEventPage = () => {
  const eventListRef: any = createRef<HTMLDivElement>()
  const scrollToEventList = async () => {
    const targetElement = await eventListRef
    targetElement?.current?.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <styled.PageContainer>
      <styled.MainVisual>
        <styled.MainVisualCard>
          <styled.MainVisualSupplement type="LargeLabel">
            在りたい自分を見つけ、
            <br />
            キャリアを掴み取るための
          </styled.MainVisualSupplement>
          <styled.MainVisualTitle type="SubHero">就活イベント</styled.MainVisualTitle>
        </styled.MainVisualCard>
      </styled.MainVisual>
      <styled.Container className="odd-blue">
        <span ref={eventListRef} />
        <Pc>
          <img src={`${staticPath("/static/images/infra-event/decoration-1.svg")}`} className="decoration d1" />
        </Pc>
        <Sp>
          <img src={`${staticPath("/static/images/infra-event/decoration-1_sp.svg")}`} className="decoration d1" />
        </Sp>
        <styled.Section>
          <styled.Heading type="SubHero">
            <h1>開催中の就活イベント一覧</h1>
          </styled.Heading>
          <styled.EventList>
            <styled.EventItem>
              <Link href={internalLink("/events/70")}>
                <div className="thumbnail-container draft">
                  <div className="title-top">
                    <div className="title-top-sub">マッチングイベント</div>
                    <div className="title-top-main">DRAFT</div>
                  </div>
                  <div className="title-bottom">まだ知らない自分の可能性に出会う</div>
                </div>
                <div className="description">
                  23卒学生と企業を集めた、少人数制の交流イベント。通常の”聞いているだけ”
                  の説明会では知ることができない、企業の「リアル」を知れるチャンスです！
                  <br />
                  視野を広げ、自分の軸や経験にマッチした 企業を見つけたい方にオススメ！
                  <styled.EventTransitionLink isButton size="Small" icon="Next" href={internalLink("/events/70")}>
                    申し込む
                  </styled.EventTransitionLink>
                </div>
              </Link>
            </styled.EventItem>
            <styled.EventItem>
              <Link href={internalLink("/events/83")}>
                <div className="thumbnail-container jobs">
                  <div className="title-top">
                    <div className="title-top-main">JOBS</div>
                    <div className="title-top-sub">-Sales-</div>
                  </div>
                  <div className="white-card">
                    <p className="white-card-description">
                      現役人事から徹底フィードバック＆
                      <br />
                      特別選考案内獲得のチャンス！
                    </p>
                    <div className="white-card-title">グループワーク強化イベント</div>
                  </div>
                </div>
                <div className="description">
                  グループワークのテーマは営業として「顧客の課題を解決する提案をする」こと。これからビジネスの現場で求められる素質を、実践形式で体感していただきます。
                  <br />
                  当日は企業人事から直接FB＆特別選考案外がもらえるチャンスも！
                  <styled.EventTransitionLink isButton size="Small" icon="Next" href={internalLink("/events/83")}>
                    申し込む
                  </styled.EventTransitionLink>
                </div>
              </Link>
            </styled.EventItem>
          </styled.EventList>
        </styled.Section>
      </styled.Container>
      <styled.Container>
        <styled.Section>
          <styled.ScoutContainer>
            <img src={`${staticPath("/static/images/infra-event/decoration-6.svg")}`} className="decoration d6" />
            <h2 className="heading">
              ＼長期インターンなど<span className="emphasis">ビジネス経験</span>がある学生
              <span className="emphasis">限定イベント！</span>／
            </h2>
            <div className="content-wrapper">
              <div className="content">
                <img src="/next/static/images/infra-event/scout-thumbnail.png" className="thumbnail" />
                <p className="description">
                  ーーーここは企業と学生の"志"が出会う場
                  <br />
                  あなたに興味を持った企業から"指名"を受け
                  <br />
                  あなたの自己プレゼン次第でその場でスカウトがもらえる。
                  <br />
                  <br />
                  あなたはスカウトを獲得することができるのか？
                  <br />
                  自分の真価が問われる、実践の場。
                </p>
              </div>
            </div>
            <styled.CvButton href={internalLink("/events/75")} size="Medium" target="_blank">
              申し込む
            </styled.CvButton>
          </styled.ScoutContainer>
        </styled.Section>
      </styled.Container>
      <styled.Container className="odd-gray">
        <styled.Section>
          <Heading
            typoPath={`${staticPath("/static/images/infra-event/typo-what-is.svg")}`}
            heading="Infraイベントって？"
            supplement="就活に役立つポイントが盛りだくさん"
          />
          <img src={`${staticPath("/static/images/infra-event/decoration-3.svg")}`} className="decoration d3" />
          <img src={`${staticPath("/static/images/infra-event/decoration-2.svg")}`} className="decoration d2" />
          <styled.Feature>
            <styled.FeatureDecoration>
              <styled.FeatureDecorationImg src={staticPath("/static/images/infra-event/measure-text.svg")} />
              <styled.FeatureDecorationLine />
            </styled.FeatureDecoration>
            <styled.FeatureCard>
              <styled.FeatureCardImg src={staticPath("/static/images/infra-event/measure-icon.svg")} />
              <styled.FeatureCardText>
                <styled.FeatureHeading type="SubHero">選考突破に向け対策ができる</styled.FeatureHeading>
                <styled.FeatureBody type="Body">
                  実践形式のグループディスカッション対策、合説型など自分の就活フェーズに合わせたイベントを無料で選べる。企業の人事担当から直接フィードバックが貰えるので、改善が進む！
                </styled.FeatureBody>
              </styled.FeatureCardText>
            </styled.FeatureCard>
          </styled.Feature>
          <styled.Feature className="reverse">
            <styled.FeatureDecoration className="reverse">
              <styled.FeatureDecorationImg src={staticPath("/static/images/infra-event/menter-text.svg")} />
              <styled.FeatureDecorationLine />
            </styled.FeatureDecoration>
            <styled.FeatureCard className="reverse">
              <styled.FeatureCardImg
                src={staticPath("/static/images/infra-event/menter-icon.svg")}
                className="reverse"
              />
              <styled.FeatureCardText>
                <styled.FeatureHeading type="SubHero">メンターはトップ企業内定者</styled.FeatureHeading>
                <styled.FeatureBody type="Body">
                  総合商社や大手IT企業などトップ企業の内定者による就活対策講座。就活を終えた先輩から体験談や就活のリアルを直接聞ける。
                </styled.FeatureBody>
              </styled.FeatureCardText>
            </styled.FeatureCard>
          </styled.Feature>
          <styled.Feature>
            <styled.FeatureDecoration>
              <styled.FeatureDecorationImg src={staticPath("/static/images/infra-event/network-text.svg")} />
              <styled.FeatureDecorationLine />
            </styled.FeatureDecoration>
            <styled.FeatureCard>
              <styled.FeatureCardImg src={staticPath("/static/images/infra-event/network-icon.svg")} />
              <styled.FeatureCardText>
                <styled.FeatureHeading type="SubHero">就活ネットワークができる</styled.FeatureHeading>
                <styled.FeatureBody type="Body">
                  イベント参加者限定のコミュニティで、横のつながりを作れる。オフラインの交流会も定期開催。
                </styled.FeatureBody>
              </styled.FeatureCardText>
            </styled.FeatureCard>
          </styled.Feature>
          <styled.Feature className="reverse">
            <styled.FeatureDecoration className="reverse">
              <styled.FeatureDecorationImg src={staticPath("/static/images/infra-event/consult-text.svg")} />
              <styled.FeatureDecorationLine />
            </styled.FeatureDecoration>
            <styled.FeatureCard className="reverse">
              <styled.FeatureCardImg
                src={staticPath("/static/images/infra-event/consult-icon.svg")}
                className="reverse"
              />
              <styled.FeatureCardText>
                <styled.FeatureHeading type="SubHero">個別相談も実施</styled.FeatureHeading>
                <styled.FeatureBody type="Body">
                  面接対策や自己分析、就活軸の探し方などを個別でサポート。個別の相談も無料でご利用いただけます。
                </styled.FeatureBody>
              </styled.FeatureCardText>
            </styled.FeatureCard>
          </styled.Feature>
        </styled.Section>
      </styled.Container>
      <styled.Container>
        <styled.Section>
          <styled.RecommendContainer>
            <Heading
              typoPath={`${staticPath("/static/images/infra-event/typo-recommend.svg")}`}
              heading="こんな方は特におすすめ"
              supplement="1つでも当てはまったら、すぐに参加しよう"
            />
            <img src={`${staticPath("/static/images/infra-event/decoration-9.svg")}`} className="decoration d9" />
            <img src={`${staticPath("/static/images/infra-event/decoration-4.svg")}`} className="decoration d4" />
            <ul className="recommend_list">
              <li>
                <img
                  src={`${staticPath("/static/images/infra-event/recommend-experience.png")}`}
                  className="recommend_list-item-img"
                />
                <Pc>
                  <Typography type="Heading" colorProp={Color.Black} className="recommend_list-item-heading">
                    これまでの経験を活かして
                    <br />
                    就活したい
                  </Typography>
                  <Typography type="Note" colorProp={Color.Gray} className="recommend_list-item-supplement">
                    経験を魅力的に伝えるノウハウだけでなく、
                    <br />
                    経験を評価する企業が集まっています。
                  </Typography>
                </Pc>
                <Sp>
                  <Typography type="SubHeading" colorProp={Color.Black} className="recommend_list-item-heading">
                    これまでの経験を活かして
                    <br />
                    就活したい
                  </Typography>
                  <Typography type="SubNote" colorProp={Color.Gray} className="recommend_list-item-supplement">
                    経験を魅力的に伝えるノウハウだけでなく、
                    <br />
                    経験を評価する企業が集まっています。
                  </Typography>
                </Sp>
              </li>
              <li>
                <img
                  src={`${staticPath("/static/images/infra-event/recommend-selection.png")}`}
                  className="recommend_list-item-img"
                />
                <Pc>
                  <Typography type="Heading" colorProp={Color.Black} className="recommend_list-item-heading">
                    早期選考に参加し就活対策したい
                    <br />
                    &内定獲得したい
                  </Typography>
                  <Typography type="Note" colorProp={Color.Gray} className="recommend_list-item-supplement">
                    面接経験や内定を掴みましょう。早期に動くことで心に余裕ができ、有利に就活を進められます。
                  </Typography>
                </Pc>
                <Sp>
                  <Typography type="SubHeading" colorProp={Color.Black} className="recommend_list-item-heading">
                    早期選考に参加し就活対策したい
                    <br />
                    &内定獲得したい
                  </Typography>
                  <Typography type="SubNote" colorProp={Color.Gray} className="recommend_list-item-supplement">
                    面接経験や内定を掴みましょう。早期に動くことで
                    <br />
                    心に余裕ができ、有利に就活を進められます。
                  </Typography>
                </Sp>
              </li>
              <li>
                <img
                  src={`${staticPath("/static/images/infra-event/recommend-company.png")}`}
                  className="recommend_list-item-img"
                />
                <Pc>
                  <Typography type="Heading" colorProp={Color.Black} className="recommend_list-item-heading">
                    学生にはあまり知られていない
                    <br />
                    優良企業を知りたい
                  </Typography>
                  <Typography type="Note" colorProp={Color.Gray} className="recommend_list-item-supplement">
                    誰もが知ってる有名企業の他にも、業界で活躍している優良企業はたくさんあります。
                  </Typography>
                </Pc>
                <Sp>
                  <Typography type="SubHeading" colorProp={Color.Black} className="recommend_list-item-heading">
                    学生にはあまり知られていない
                    <br />
                    優良企業を知りたい
                  </Typography>
                  <Typography type="SubNote" colorProp={Color.Gray} className="recommend_list-item-supplement">
                    誰もが知ってる有名企業の他にも、
                    <br />
                    業界で活躍している優良企業はたくさんあります！
                  </Typography>
                </Sp>
              </li>
            </ul>
          </styled.RecommendContainer>
          <div onClick={scrollToEventList}>
            <styled.CvButton href="javascript:void(0)" size="Medium">
              イベントに申し込む
            </styled.CvButton>
          </div>
        </styled.Section>
      </styled.Container>
      <styled.Container className="odd-blue">
        <styled.Section>
          <img src={`${staticPath("/static/images/infra-event/decoration-7.svg")}`} className="decoration d7" />
          <styled.Heading type="SubHero">個別にイベントを紹介して欲しい方へ</styled.Heading>
          <styled.LineConsultation>
            自己分析、エントリーシート、面接対策、etc...
            <br />
            悩んでいること何でも聞いてください！
            <br />
            適切なイベントのご紹介やアドバイスをいたします！
          </styled.LineConsultation>
          <styled.CvButton href="https://lin.ee/v9j1WXe" size="Medium" target="_blank">
            LINEから相談する
          </styled.CvButton>
        </styled.Section>
      </styled.Container>
    </styled.PageContainer>
  )
}
